"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptConfigParams = void 0;
var getScriptUrl_1 = require("./getScriptUrl");
function getScriptConfigParams() {
    var dataAttributesParams = getParamsFromDataAttributes();
    if (dataAttributesParams) {
        return dataAttributesParams;
    }
    var searchParamsParams = getParamsFromSearchParams();
    if (searchParamsParams) {
        return searchParamsParams;
    }
    return;
}
exports.getScriptConfigParams = getScriptConfigParams;
function getParamsFromDataAttributes() {
    var currentScript = document.currentScript;
    if (!currentScript) {
        return;
    }
    var projectName = currentScript.getAttribute('data-projectName');
    var requestId = currentScript.getAttribute('data-requestId');
    if (!projectName) {
        return;
    }
    return { projectName: projectName, requestId: requestId };
}
function getParamsFromSearchParams() {
    var scriptSrc = (0, getScriptUrl_1.getScriptUrl)();
    if (!scriptSrc) {
        return;
    }
    var scriptURL = new URL(scriptSrc, window.location.origin);
    var projectName = scriptURL.searchParams.get('projectName');
    var requestId = scriptURL.searchParams.get('requestId');
    if (!projectName) {
        return;
    }
    return { projectName: projectName, requestId: requestId };
}
//# sourceMappingURL=getScriptConfigParams.js.map